import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtils';
import { appUsageDefaultState } from '../../hooks/useAppUsageHook';

const storeStateActions = mapDefaultValuesToActions(appUsageDefaultState);

export default reduxReducerHelper(storeStateActions, appUsageDefaultState, false);
